import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpLinkedProcessInstanceWorklogContainerModel, MrpProcessInstanceWorklogContainerModel } from '../../../../../../models/aggregates/mrp-prodsys';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MrpLinkedProcessInstanceWorklogService extends BaseApiTemplateService<MrpLinkedProcessInstanceWorklogContainerModel
> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "mrp-process-instance-work-log-linked/" + Core2Config.BACKOFFICE_EP_SUFFIX

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX
      + Core2Config.MRP_PREFIX + "mrp-process-instance-work-log-linked/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX
      + "mrp-process-instance-work-log-linked/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  public postWorklog(dtoObject: MrpProcessInstanceWorklogContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<MrpLinkedProcessInstanceWorklogContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<MrpLinkedProcessInstanceWorklogContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public put(dtoObject: MrpProcessInstanceWorklogContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<MrpLinkedProcessInstanceWorklogContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<MrpLinkedProcessInstanceWorklogContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}